<template>
    <div class="browse">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="d-flex justify-content-around">
                    <!-- <div class="text-left mt-3 ml-5 mb-4">
            <a-icon class="mr-1" type="arrow-left" />
            <span class="go-back" @click="$router.back()">Go Back</span>
          </div> -->
                    <div class="browse-sort mx-auto mt-2">
                        <a-tabs defaultActiveKey="1j" v-model="currentKey" @tabClick="getCurrentTab">
                            <a-tab-pane tab="Job Type" :key="1 + 'j'">
                                <div v-if="showFilters" class="text-left px-3 px-md-5">
                                    <a-checkbox-group
                                        v-model="job_type"
                                        :options="jobOptions"
                                        @change="onTypeChange"
                                        class="jobTypes"
                                    />
                                </div>
                            </a-tab-pane>
                            <a-tab-pane tab="Project Type" :key="2 + 'j'">
                                <div class="text-left px-3 px-md-5" v-if="showFilters">
                                    <div class="">
                                        <label for="opt1" class="radio text-left" style="margin: 10px;">
                                            <input
                                                type="radio"
                                                name="rdo"
                                                id="opt1"
                                                class="hidden"
                                                :value="1"
                                                v-model="data.filters.commitment"
                                            />
                                            <span class="label"></span>Hourly
                                        </label>
                                    </div>
                                    <div class="">
                                        <label for="opt2" class="radio text-left" style="margin: 10px;">
                                            <input
                                                type="radio"
                                                name="rdo"
                                                id="opt2"
                                                class="hidden"
                                                :value="2"
                                                v-model="data.filters.commitment"
                                            />
                                            <span class="label"></span>Fixed </label
                                        ><br />
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane tab="Skill" :key="3 + 'j'">
                                <a-select
                                    v-if="showFilters"
                                    mode="multiple"
                                    class="w-100"
                                    size="large"
                                    placeholder="Enter/Choose skills"
                                    v-model="data.filters.skills"
                                >
                                    <a-select-option v-for="stack in specs" :key="stack" :value="stack.toLowerCase()">
                                        {{ stack }}
                                    </a-select-option>
                                </a-select>
                            </a-tab-pane>
                            <a-tab-pane tab="Price Range" :key="4 + 'j'">
                                <div class="text-center px-3 px-md-5" v-if="showFilters">
                                    <a-slider
                                        :step="10"
                                        :min="0"
                                        :max="10000"
                                        :defaultValue="0"
                                        @change="onChange"
                                        @afterChange="onAfterChange"
                                    />
                                    <h5 class="mt-3 ml-4 latest">${{ formatAmount(data.filters.budget) }}</h5>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane tab="Location" :key="5 + 'j'">
                                <a-select
                                    v-if="showFilters"
                                    class="w-100"
                                    size="large"
                                    show-search
                                    @change="getLocation"
                                    placeholder="Please select your Country"
                                >
                                    <a-select-option
                                        v-for="(item, index) in countries"
                                        :key="index"
                                        :value="item.name"
                                        >{{ item.name }}</a-select-option
                                    >
                                </a-select>
                            </a-tab-pane>
                            <a-tab-pane tab="Language" :key="6 + 'j'">
                                <div v-if="showFilters" class="text-left px-3 px-md-5 d-flex justify-content-between">
                                    <label class="checkbox-label mb-1">
                                        <input type="checkbox" checked />
                                        <span class="checkbox-custom rectangular"></span
                                        ><span class="pl-5 mb-3 ctrl-size-2">English</span> </label
                                    ><br />
                                </div>
                            </a-tab-pane>
                            <a-tab-pane tab="Hide Filter" key="7j"> </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8">
                        <div class="row browse-list mt-4 mx-auto">
                            <div class="col-6 col-md-8 pl-0">
                                <a-input
                                    class="px-0"
                                    size="large"
                                    placeholder="Search"
                                    v-model="searchText"
                                    ref="searchInput"
                                    autofocus
                                >
                                    <a-icon slot="prefix" type="search" />
                                    <a-tooltip slot="suffix" title="Extra information">
                                        <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
                                    </a-tooltip>
                                </a-input>
                            </div>

                            <div class="col-6 col-md-4 pr-0">
                                <button
                                    @click="resetFilter"
                                    class="btn-kovatek py-2 px-4 px-md-5 add-rounded float-right"
                                >
                                    Reset Filters
                                </button>
                            </div>
                        </div>

                        <div class="mt-4 mb-5 browse-list mx-auto">
                            <div class="mt-6 text-center" v-if="loading">
                                <hollow-dots-spinner
                                    :animation-duration="1000"
                                    :dot-size="15"
                                    :dots-num="5"
                                    color="#20409a"
                                    class="mx-auto"
                                />
                                <br />
                                <p>{{ !filtered ? 'Filtering...' : 'Getting Projects...' }}</p>
                            </div>

                            <div class="p-4 bg-light border shadow-sm add-rounded" v-else>
                                <div v-if="projects.length">
                                    <div v-if="filteredProjects">
                                        <template v-for="(proj, i) in projects">
                                            <job
                                                :key="proj.ID + 'cd'"
                                                :project="proj"
                                                :isSaved="checkIfJobIsSaved(proj.ID)"
                                                @refresh-profile="fetchSavedJobs"
                                            />
                                            <hr :key="proj.ID + 'd'" v-if="i + 1 !== filteredProjects.length" />
                                        </template>
                                    </div>
                                    <div class="text-center" style="font-size: 18px" v-else>
                                        <p class="my-5">No matches were found</p>
                                    </div>
                                </div>
                                <div class="text-center" style="font-size: 18px" v-else>
                                    <p class="my-5">
                                        {{
                                            !filtered
                                                ? 'This kind of project is not available at this moment!'
                                                : 'There are no projects available at this moment!'
                                        }}
                                    </p>
                                </div>
                                <a-pagination
                                    v-if="filteredProjects.length > 10"
                                    showQuickJumper
                                    v-model="currentPage"
                                    :total="10"
                                    @change="pagination"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3 pt-lg-4 mt-lg-4">
                        <div class="ml-lg-4 mt-2" style="position:sticky; top: 75px;">
                            <Notifications />
                            <!-- <Messages /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import Notifications from '@/components/Notifications.vue';
import Job from '../components/projects/Job.vue';
// import Messages from '@/components/Messages.vue';

import { HollowDotsSpinner } from 'epic-spinners';
import ProfileMixin from '../mixins/profile';

import { frontEndStacks, backEndStacks, uiTools, jobTypes } from '../data/resources';
import countries from '../data/countries.json';
import specs from '../data/specializations.json';

import { getSavedJobs } from '../utils';

const stacks = [...frontEndStacks, ...backEndStacks, ...uiTools].filter(key => key !== 'Others');
const filters = {
    type: 0,
    duration: null,
    commitment: null,
    status: null,
    budget: 0,
    complexity: null,
    skills: [],
    location: '',
};

export default {
    name: 'browse',
    mixins: [ProfileMixin],
    components: {
        Navbar,
        Footers,
        Notifications,
        // Messages,
        HollowDotsSpinner,
        Job,
    },
    data() {
        return {
            specs,
            countries,
            currentPage: 1,
            stacks,
            showFilters: true,
            workHistory: [],
            projects: [],
            range: [],
            loading: true,
            data: {
                offset: 0,
                limit: 10,
                filters,
            },
            searchText: '',
            currentKey: '1j',
            profileData: {},
            job_type: [],
            indeterminate: true,
            checkAll: false,
            savedJobs: [],
        };
    },
    computed: {
        filteredProjects() {
            return this.projects.filter(key => key.Title.toLowerCase().includes(this.searchText.toLowerCase()));
        },
        filtered() {
            const { duration, commitment, budget, status, complexity, skills, location } = this.data.filters;

            return (
                (this.job_type || []).length === 0 &&
                !duration &&
                !commitment &&
                !budget &&
                !status &&
                !complexity &&
                (skills || []).length === 0 &&
                (location || '').length == 0
            );
        },
        jobOptions() {
            return jobTypes.map(i => ({ label: i.type, value: i.id }));
        },
    },
    watch: {
        data: {
            handler() {
                this.browseProject();
            },
            deep: true,
        },
    },
    methods: {
        fetchSavedJobs() {
            const data = getSavedJobs();

            console.log({ data });
            this.savedJobs = data;
        },
        checkIfJobIsSaved(projectID) {
            const savedJob = this.savedJobs.map(key => String(key.Project.ID)).includes(String(projectID));
            return savedJob;
        },
        onTypeChange(job_type) {
            this.indeterminate = !!job_type.length && job_type.length < this.jobOptions.length;
            this.checkAll = job_type.length === this.jobOptions.length;

            this.data.filters.type = job_type.length === 1 ? Number(job_type.toString()) : 0;
        },
        onCheckAllChange(e) {
            Object.assign(this, {
                job_type: e.target.checked ? this.jobOptions : [],
                indeterminate: false,
                checkAll: e.target.checked,
            });
        },
        checkIfArraysAreEqual: (arr, target) => target.every(v => arr.includes(v)),
        onChange(value) {
            this.data.filters.budget = value;
        },
        onAfterChange(value) {
            console.log('after-change: ', value);
        },
        getCurrentTab(event) {
            if (this.currentKey === event) return (this.showFilters = !this.showFilters);
            this.currentKey = event;
            this.showFilters = true;
        },
        pagination() {},
        getLocation(val) {
            this.data.filters.location = val;
        },
        resetFilter() {
            this.data.filters = {
                type: [],
                duration: null,
                commitment: null,
                status: null,
                budget: 0,
                complexity: null,
                skills: [],
                location: '',
            };
        },
        browseProject() {
            this.loading = true;

            this.$store
                .dispatch('projects/browseProject', this.data)
                .then(resp => {
                    this.projects = resp.data;
                    this.$store.commit('setLoader', false);
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    this.$store.commit('setLoader', false);
                });
        },
    },
    async mounted() {
        this.$store.commit('setLoader', true);
        try {
            await Promise.all([this.browseProject(), this.getProfile(), this.fetchSavedJobs()]);
        } catch (e) {
            console.log(e);
        }
    },
};
</script>

<style scoped>
.browse-sort {
    width: 80%;
}
.sort-by {
    position: relative;
    top: 33px;
}
.icon-size {
    font-size: 25px;
}
.icon-size1 {
    font-size: 20px;
}
.img-height {
    width: 90px;
    height: 90px;
}
.icon-env {
    font-size: 20px;
}
.ctrl-size {
    font-size: 11px;
}
.ctrl-size-1 {
    font-size: 20px;
}
.ctrl-size-2 {
    font-size: 12px;
}
.latest {
    color: #2db7f5;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .img-height {
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
    .browse-sort {
        width: 100%;
    }
}

@media screen and (max-width: 550px) {
    .ctrl-search {
        width: 55%;
    }
    .img-height {
        width: 75px;
        height: 75px;
    }
}
</style>
